<template>
  <TableRow>
    <CellSkeleton
      v-for="column in filteredColumns"
      :class="{
        'border-l': first(filteredColumns) == column,
        'border-r': last(filteredColumns) == column,
        'rounded-bl-xl': first(filteredColumns) == column && isLast,
        'rounded-br-xl': last(filteredColumns) == column && isLast,
      }"
      :key="'loading_cell_' + column.id"
      :column="column"
      :maxWidthResponsiveColumn="maxWidthResponsiveColumn"
    />
  </TableRow>
</template>

<script setup>
import { TableRow } from "@/Shadcn/Components/ui/table";
import { CellSkeleton } from "@/Components/DataTable";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { computed } from "vue";
import { last, first } from "lodash";

const { breakpoints, width } = useBreakpoints();

const props = defineProps({
  isLast: { type: Boolean, default: false },
  columns: { type: Array, required: true },
  maxWidthResponsiveColumn: { type: Number, required: false },
});

const filteredColumns = computed(() =>
  props.columns.filter(
    (column) =>
      (breakpoints[column.meta.visibility] || Number(column.meta.visibility)) <
      width.value
  )
);
</script>
